import type { JobTemplateQuestion } from '@jms/model';

/** Same words the legacy Show Condition cell printed. */
export function jobTemplateQuestionShowConditionLabel(question: Pick<JobTemplateQuestion, 'showCondition'> | null | undefined): string {

  return question?.showCondition ? 'Enabled' : 'Always';
}
